import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import { OtpApi, SendOtpApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails, setloggedIn } from "../../store/slices/userSlice.js";
import { setCookies } from "../../services/Cookies.jsx";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import ConfirmationModal from "../../components/modals/ConfirmationModal.jsx";
import { IpProvider } from "../../services/IpProvider.js";

function Otp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [FormData, setFormData] = useState({ otp: "" });
  const [ipAddress, setIpAddress] = useState("");

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const getIpAddress = async () => {
    try {
      const { data } = await IpProvider();
      setIpAddress(data?.ip);
    } catch (error) { }
  };

  useEffect(() => {
    getIpAddress();
  }, []);

  useEffect(() => {
    setInterval(() => {
      setTimer((current) => (current !== 0 ? current - 1 : 0));
    }, 1000);
  }, []);

  const multipleLoginConfirm = () => {
    setIsOpen(false);
    handleSubmit(null, true);
  };

  const handleSubmit = async (values, allowMutiLogin) => {
    const { otp } = FormData;
    const email = JSON.parse(localStorage.getItem("email"));
    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        email,
        otp: otp?.toString(),
        loginType: "web",
        ipAddress: ipAddress,
        // allowMutiLogin: allowMutiLogin ? allowMutiLogin : false,
      };
      const { data } = await OtpApi(params);
      if (data?.error?.foundMultipleLogin) {
        setIsOpen(true);
      } else {
        setCookies("token", data?.data?.authToken);
        dispatch(setloggedIn(true));
        let user = data?.data;
        delete user?.authToken;
        dispatch(setUserDetails(user));
        if (user?.clientVerify === false) {
          navigate("/client_profile");
        } else {
          navigate("/dashboard");
        }
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred.");
      setIsLoading(false);
    }
  };
  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };

  const sharedProps = {
    onChange,
  };

  const resendOTPHandler = async () => {
    try {
      const { data } = await SendOtpApi(localStorage.getItem('email'));
      if (data?.success) {
        toast.success(data?.message);
        setFormData({ otp: "" });
        setTimer(120);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "An error occurred.");
    }
  };

  return (
    <>
      <div className="flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg">
        <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-xl">
          <div className="flex justify-center mb-6">
            <img
              src="/assets/logo/logo.png"
              alt="logo"
              className="h-20 w-48 object-contain "
            />
          </div>
          <div className="text-center mb-5">
            <p className="text-[#2F2B3D] text-2xl font-semibold auth-heading">
              OTP Verification
            </p>
            <p className="text-[silver] text-sm font-medium auth-com mt-2">
              Please enter the OTP and verify yourself
            </p>
          </div>
          <div className="w-full">
            <Form autoComplete="off" onFinish={handleSubmit}>
              <div className="w-full text-sm py-1">
                <div className="relative">
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input.OTP
                      variant="filled"
                      {...sharedProps}
                      value={FormData.otp}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="my-6 flex justify-center">
                {timer == 0 ? (
                  <button
                    onClick={resendOTPHandler}
                    className="text-sm primary font-bold"
                  >
                    <span className="text-black font-normal">
                      Didn't receive it?
                    </span>{" "}
                    Resend OTP
                  </button>
                ) : (
                  <p>Resend OTP in {formatTime(timer)}</p>
                )}
              </div>
              <div className="mt-8">
                <LoadableButton
                  type="submit"
                  className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text"
                  lable="Verify"
                  isLoading={isLoading}
                  loadingLable="Verifying..."
                />
              </div>
              <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/" className="">
                  Back to login
                </a>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        message="User is already logged in on the website. Please log out before attempting to log in again."
        onConfirm={multipleLoginConfirm}
      />
    </>
  );
}

export default Otp;
